/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner
 */
export interface PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner {
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner
     */
    productId: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner
     */
    priceImpact?: number | null;
}

/**
 * Check if a given object implements the PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner interface.
 */
export function instanceOfPatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner(value: object): value is PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerFromJSON(json: any): PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner {
    return PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerFromJSONTyped(json, false);
}

export function PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'productId': json['productId'],
        'enabled': json['enabled'],
        'name': json['name'],
        'priceImpact': json['priceImpact'] == null ? undefined : json['priceImpact'],
    };
}

export function PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerToJSON(json: any): PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner {
    return PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerToJSONTyped(json, false);
}

export function PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerToJSONTyped(value?: PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'categoryId': value['categoryId'],
        'productId': value['productId'],
        'enabled': value['enabled'],
        'name': value['name'],
        'priceImpact': value['priceImpact'],
    };
}

